module.exports = __webpack_public_path__ + "static/media/lightCheckBox.7112db70.svg";